exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".action-icons[data-v-494798e0]{display:-webkit-box;display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/webuser/wolf/releases/294/spa/src/pages/sales/saleTable/SaleTable.vue"],"names":[],"mappings":"AACA,+BACE,oBAAA,oBAAA,YAAA,CAAA","file":"SaleTable.vue?vue&type=style&index=0&id=494798e0&prod&lang=scss&scoped=true","sourcesContent":["\n.action-icons {\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports
